<template>
  <div id="coups-de-coeur-home-phone">
    <div class="pb-5">
      <div class="row row-hubs">
        <div class="col-12 d-flex justify-content-center align-items-center">
          <div class="lodging-header text-center">
            <h2 class="merriweather-reg-20">Nos</h2>
            <h2 class="merriweather-reg-28">Coups de Cœur</h2>
            <p class="merriweather-light-18 mb-5">Chaque adresse sélectionnée par<br> Hortense vous réserve des <span class="merriweather-light-italic-18">privilèges<br>exclusifs</span></p>
          </div>
        </div>
        <div class="card-container">
          <div class="container-fluid py-2 position-relative">
          <div class="d-flex flex-row flex-nowrap" id="scroller" style="overflow: scroll; overflow-y: hidden">
            <div class="card card-body border-0" v-if="lodgings"  v-for="lodging in lodgings" :key="lodging.id" style="min-height: auto; min-width: auto; margin-right:25px; max-width: 334px;">
            <CardProductHome data-aos="fade-up" data-aos-duration="900" :lodging="lodging" :user="isUserConnected()" @connection="$emit('connection')"></CardProductHome>
            </div>
          </div>
        </div>
        <div class="row experience-card-leave mt-4">
          <div class="d-flex flex-column align-items-center justify-content-between">
            <div class="d-flex flex-row align-items-center justify-content-between" style="gap: 12px;">
              <div class="leave-left">
                <img src="../images/greenFull.svg" alt="feuille gauche" class="img-leaf-left">
              </div>
              <div class="raleway-bold-h3 text-nowrap">La Green Note</div>
              <div class="leave-right">
                <img src="../images/greenFull.svg" alt="feuille droite" class="img-leaf-right">
              </div>
            </div>
            <div class="d-flex flex-column align-items-center justify-content-center text-center">
              <p class="raleway-reg-p15">Hortense sélectionne des hébergements alliant charme et engagement écologique. Chaque établissement est <strong>évalué</strong> selon notre <strong>Green Note</strong> (minimum 5/10) et sélectionné pour son <strong>cadre exceptionnel</strong>, sa <strong>démarche durable</strong> et <strong>l’unicité de son expérience.</strong></p>
              <p class="raleway-reg-p15 pt-2 cursor-pointer underline_text" @click="goToGroup('https://www.hortense.green/la-green-note')">
                En savoir plus
              </p>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-center justify-content-center lodging-redirect-btn">
      <a class="hortense-btn-primary raleway-bold-p" :href="'/reservation-hotel'" target="_blank">Découvrir notre sélection</a>
    </div>
  </div>
</template>

<script>
import CardProduct from './cards/CardProduct.vue';
import CardProductHome from "./cards/CardProductHome.vue";
import AOS from "aos";

export default {
  name: 'CoupsDeCoeurHomePhone',
  props: {
    lodgings: Array,
    user: Object
  },
  components: {CardProductHome, CardProduct },
  data() {
    return {};
  },
  methods: {
    autoScroll() {
      const scroller = document.getElementById('scroller');
      const step = 1; // Adjust step for speed
      let maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;

      const frame = () => {
        if (scroller.scrollLeft >= maxScrollLeft) {
          scroller.scrollLeft = 0; // Reset scroll to start when it reaches the end
          maxScrollLeft = scroller.scrollWidth - scroller.clientWidth; // Recalculate in case of dynamic content
        } else {
          scroller.scrollLeft += step;
        }
        requestAnimationFrame(frame);
      }
      frame();
    },
    goToGroup(url){
      //Turbolinks.visit(url);
      window.open(url, '_blank');
    },
    isUserConnected() {
      return this.user ? this.user : {};
    },
    scroll_left() {
      let content = document.querySelector("#scroller");
      content.scrollLeft -= 220;
    },
    scroll_right() {
      let content = document.querySelector("#scroller");
      content.scrollLeft += 220;
    }
  },
  mounted() {
    AOS.init();
    this.autoScroll();
  }
};
</script>
<style scoped>

  #coups-de-coeur-home-phone {

    .hub-img, .hub-img-zoom {
      width: 334px !important;
      height: 277px !important;
    }

    .card-container {
      padding-left: unset !important;
      padding-right: unset !important;
    }
    padding-top: 55px;
    .circle-icon {
      width: 44px;
      height: 46px;
      border: 1px solid #F7F7F7;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .previous-slide-button {
      position: absolute;
      top: 30%;
      transform: translateY(-50%);
      left: 0;
      color: #F7F7F7;
      background-color: #F7F7F7;

      i {
        color: black;
      }
    }

    .next-slide-button {
      position: absolute;
      top: 30%;
      transform: translateY(-50%);
      right: 0;
      color: #F7F7F7;
      background-color: #F7F7F7;

      i {
        color: black;
      }
    }

    .container-fluid {
      padding-left: 50px;
      padding-right: 50px;
    }
  }
  .experience-card-leave {
    background-image: linear-gradient(270.13deg, rgba(255, 255, 255, 0) 12.44%, rgba(255, 255, 255, 0.8) 58.96%),
      url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-club-green-note.jpg');
    width: 100%;
    height: 264px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 13px;
    padding-left: 44px;

    .leave-left, .leave-right, .img-leaf-left, .img-leaf-right {
      width: 40px;
      height: 40px;
    }
  }

  .underline_text {
    text-decoration: underline;;
  }
  
</style>